import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import StorefrontUsageTrackerContext from '../context/StorefrontUsageTrackerContext'; // @ts-expect-error module is untyped

import { getBeforeUnloadTracker, getUsageTracker } from '../utils/usageTracker';

const makeTrackEvent = (usageTracker, defaultEventProperties) => (eventName, eventProperties = {}) => {
  usageTracker.track(eventName, Object.assign({}, defaultEventProperties, {}, eventProperties));
};

export default function StorefrontUsageTrackerProvider({
  children
}) {
  const [defaultEventProperties, setDefaultEventProperties] = useState({});
  const usageTrackerContextValue = useMemo(() => {
    const trackEvent = makeTrackEvent(getUsageTracker(), defaultEventProperties);
    const trackBeforeUnloadEvent = makeTrackEvent(getBeforeUnloadTracker(), defaultEventProperties);
    return {
      trackEvent,
      trackBeforeUnloadEvent,
      trackPageview: trackEvent.bind(null, 'pageView'),
      trackFilterView: trackEvent.bind(null, 'storefront-filter-view'),
      trackInteraction: (action, eventProperties = {}) => trackEvent('interaction', Object.assign({}, eventProperties, {
        action
      })),
      trackBeforeUnloadInteraction: (action, eventProperties = {}) => trackBeforeUnloadEvent('interaction', Object.assign({}, eventProperties, {
        action
      })),
      setDefaultEventProperties
    };
  }, [defaultEventProperties]);
  return /*#__PURE__*/_jsx(StorefrontUsageTrackerContext.Provider, {
    value: usageTrackerContextValue,
    children: children
  });
}